<template>
  <div v-if="modal" class="overlay">
      <div class="overlay_inner wide">
        <p class="note" v-translate>Vyhledat vysílání</p>
        <div class="broadcast_search">
          <div class="popup_filter">

            <div class="field_left">
              <search-input
                  input-class="search clearable"
                  v-model="name_search"
                  @input="onSearch"
              />
            </div>

            <multiselect-searchbox
                :searchFunction="searchChannels"
                v-model="ids_epg"
                :show-id="true"
                @input="onSearch"
            >
              <translate class="translate">Kanály</translate>
            </multiselect-searchbox>

            <div class="field_left">
              <date-picker
                  id="time_from"
                  attrKey="time_from"
                  date-format="d. m. yy"
                  edit-time
                  v-model="time_from"
                  @update-date="updateDate"
              >
                <translate class="translate">Datum a čas od</translate>
              </date-picker>
            </div>

            <div class="field_right">
              <date-picker
                  id="time_to"
                  attrKey="time_to"
                  date-format="d. m. yy"
                  edit-time
                  v-model="time_to"
                  @update-date="updateDate"
              >
                <translate class="translate">Datum a čas do</translate>
              </date-picker>
            </div>

            <div class="field_left field_chekradio">
              <radio-input
                  id="desc"
                  name="desc"
                  p-class="field"
                  v-model="start_ordering"
                  :val="start_ordering"
                  @input="onSearch"
              >
                <translate class="translate">Sestupně</translate>
              </radio-input>
              <radio-input
                  id="asc"
                  name="asc"
                  p-class="field"
                  v-model="start_ordering"
                  :val="start_ordering"
                  @input="onSearch"
              >
                <translate class="translate">Vzestupně</translate>
              </radio-input>
            </div>
            <div class="field_right">
              <div class="pagination" v-if="!loading">
                <ul>
                  <li>
                    <a class="pagination_prev" v-if="offset > 0" @click.stop="getPrevious" />
                  </li>
                  <li>
                    <a class="pagination_next" v-if="next_page" @click.stop="getNext" />
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="popup_filter_results" v-if="broadcasts.length > 0">
            <table class="vypis">
              <tbody>
              <tr v-for="broadcast in broadcasts"
                  :key="broadcast.id"
                  class="clickable"
              >
                <td class="no_padding drag_drop"><span></span></td>
                <td class="no_padding">
                  <input
                      type="checkbox"
                      :id="broadcast.id"
                      :value="broadcast.id"
                      @click.stop
                      @change="selectBroadcast"
                      :checked="broadcastChecked(broadcast.id)"
                  />
                  <label :for="broadcast.id" @click.stop v-translate>Vybrat</label>
                </td>
                <td>{{ broadcast.id }}</td>
                <td>{{ broadcast.text }}</td>
                <td>{{ broadcast.channel_name }}</td>
                <td>{{ broadcast.datetime }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <a @click.stop="showModal(false)"
           class="btn btn_action btn_close"
           :title="$gettext('Zavřít')"
           v-translate>Zavřít</a>
      </div>
    </div>
</template>

<script>
export default {
  name: "BroadcastSearch",
  components: {},
  props: {
    value: Array,
    multiple: {
      type: Boolean,
      default: true
    }
  },
  created(DashboardCarouselService, ChannelService) {
    this.dashboardCarouselService = DashboardCarouselService
    this.channelService = ChannelService
    this.selected = this.value ? this.value.map(id => String(id)) : []
  },
  data() {
    return {
      modal: false,
      loading: false,
      selected: [],
      name_search: null,
      ids_epg: [],
      time_from: null,
      time_to: null,
      start_ordering: 'desc',
      offset: 0,
      limit: 4,
      broadcasts: [],
      next_page: false,
    }
  },
  methods: {
    showModal(show, data) {
      if(show === false) {
        this.searchBroadcastsById(this.selected)
      }
      this.modal = show;
      this.selected = data ? data.map(id => String(id)) : []
    },
    updateDate(dateInfo) {
      // format to timestamp
      this[dateInfo.attrKey] = dateInfo.date
      this.onSearch()
    },
    searchChannels(search, selectAll = false) {
      return this.channelService.searchChannelIdEpgsByName({
        search: search,
        active_in_platform: true,
        id_selected_operator: this.$_loggedUser_selectedOperatorId,
        select_all: selectAll
      });
    },
    selectBroadcast(e) {
      if (e.target.checked) {
        if(this.multiple) {
          this.selected.push(String(e.target.value))
        } else {
          this.selected = [e.target.value]
        }
      } else {
        this.selected = this.selected.filter(id => id !== String(e.target.value))
      }
      this.$emit('input', this.selected)
    },
    broadcastChecked(id) {
      return this.selected.indexOf(String(id)) > -1
    },
    onSearch() {
      clearTimeout(this.keyTimer);
      this.keyTimer = setTimeout(this.searchBroadcast, this.keyPressTimeoutMiliseconds);
    },
    searchBroadcast(resetOffset = true) {
      this.next_page = false
      if (resetOffset) {
        this.offset = 0
      }
      if (!this.name_search) {
        return
      }
      this.loading = true
      this.dashboardCarouselService.searchBroadcastsByName({
        name_search: this.name_search,
        ids_epg: this.ids_epg,
        time_from: this.time_from,
        time_to: this.time_to,
        start_ordering: this.start_ordering,
        id_selected_operator: this.$_loggedUser_selectedOperatorId,
        offset: this.offset,
        limit: this.limit,
      }).then(response => {
        this.broadcasts = response.data
        this.loading = false
        this.next_page = response.next_page;
      })
    },
    searchBroadcastsById(ids) {
      if (!ids || ids.length === 0) {
        return;
      }
      this.dashboardCarouselService.searchBroadcastsByName({ ids: ids.join(',') }).then(response => {
        const broadcastNames = {}
        response.data.forEach(item => {
          broadcastNames[item.id] = item
        })
        this.$emit('broadcast-search-names', broadcastNames)
      })
    },
    getPrevious() {
      if (this.offset === 0) {
        return
      }
      this.offset = Math.max(this.offset - this.limit, 0)
      this.searchBroadcast(false)
    },
    getNext() {
      if (!this.next_page) {
        return
      }
      this.offset = this.offset + this.limit
      this.searchBroadcast(false)
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/BroadcastSearch.vue